// extracted by mini-css-extract-plugin
export default {"dark":"panel-wrapper_dark__-NIUe","gradient":"panel-wrapper_gradient__gYvD-","light":"panel-wrapper_light__04u5v"};